/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripDaySolveProcessPhase = {
    Pending: 'Pending',
    Preparing: 'Preparing',
    Solving: 'Solving',
    Allocating: 'Allocating',
    CheckingAttendants: 'CheckingAttendants',
    Persisting: 'Persisting',
    Finalizing: 'Finalizing',
    Completed: 'Completed'
} as const;
export type TaxiTripDaySolveProcessPhase = typeof TaxiTripDaySolveProcessPhase[keyof typeof TaxiTripDaySolveProcessPhase];

